module.exports = __webpack_public_path__ + "img/blinking_aria_poster.c8646021.png";